<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<div v-if="$store.getters.isAuthorized(['ROLE_MANAGER'])" class="form-row">
										<div align="center" class="col-md-6">
											<div class="btn-group" style="float: right;">
												<button class="btn btn-primary btn-sm" @click="modalToggle('NEW')" >
													<fa icon="add"/>&nbsp;
													{{ $t('default.button.add') }}
												</button>
											</div>
										</div>
									</div>
									<!-- <div id="panelList" class="card-body  panel-collapse collapse in show"> -->
									<div class="form-row">
										<div class="col-md-8">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsPerson')}}
												</label>
												<auto-search :paramsSearch="paramsSearch" @updateOnClick="addPrsPerson" />

												<input type="text" v-model="instance.prsPerson" class="form-control" hidden=""/>								
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.active')}}
												</label>
												<select v-model="instance.active" class="form-control">
													<option :value="true">Oui</option>
													<option :value="false">Non</option>
												</select>										
											</div>
										</div>
										
										
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountInf', { obj: $t(instanceClassAttr.instanceClass+'.solde')} ) }}</label>
												<input type="number" step="any" v-model="instance.soldeInf" class="form-control" @input="amountToLetter($event, 'inf')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.inf != '' " class="amount-letter">
													{{amountLetter.inf}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountEq', { obj: $t(instanceClassAttr.instanceClass+'.solde')})}}</label>
												<input type="number" step="any" v-model="instance.soldeEq" class="form-control" @input="amountToLetter($event, 'eq')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.eq != '' " class="amount-letter">
													{{amountLetter.eq}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountSup', { obj: $t(instanceClassAttr.instanceClass+'.solde')})}}</label>
												<input type="number" step="any" v-model="instance.soldeSup" class="form-control" @input="amountToLetter($event, 'sup')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.sup != '' " class="amount-letter">
													{{amountLetter.sup}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsType')}}
												</label>
												<select v-model="instance.prsType" class="form-control" multiple>
													<option v-for="prsType in prsTypeList" :value="prsType.id" :key="prsType.id">
													{{ prsType.typeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
												</label>
												<select v-model="instance.prsStore" class="form-control" multiple>
													<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id">
													{{ prsStore.storeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.mvtBank')}}
												</label>
												<select v-model="instance.mvtBank" class="form-control" multiple>
													<option v-for="mvtBank in mvtBankList" :value="mvtBank.id" :key="mvtBank.id">
													{{ mvtBank.bankCode}}
													</option>
												</select>	
												
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.dateEntryAfter')}}</label>
												<input type="date" v-model="instance.dateEntryAfter" class="form-control" />
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.dateEntryBefore')}}</label>
												<input type="date" v-model="instance.dateEntryBefore" class="form-control" />
											</div>
										</div>
										

									</div> <!--end form-row-->
									<div style="text-align:center">
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>
										&ensp;
										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

										<!-- </div> -->
								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<div>
							<chart
								:typeStats="typeStats"
								:chartData="chartData"
								:chartOptions="chartOptions"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<!-- DATA -->
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttr"
								ref="componentDatatableInstance"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				
			</vue-collapsible-panel-group>

			<!-- ModalInstance  -->
			<div ref="modalInstance" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
				<div class="modal-dialog modal-dialog-centered modal-lg"
					role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" v-if="modalType == 'NEW'">
								{{ $t('default.new') }}
							</h5>
							<h5 class="modal-title" v-if="modalType == 'EDIT'">
								{{ $t('default.edit') }}
							</h5>
							<b-button type="button" variant="close" @click="modalToggle()" />
						</div>
						<div class="modal-body">
							<b-container>
								<form role="form" id="modalFormInst" @submit.prevent="axiosPost">
									<div class="row d-flex justify-content-center ">
										<div class="col-md-8">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsPerson')}}
												</label>
												<auto-search :paramsSearch="paramsSearch" @updateOnClick="addPrsPerson" />

												<input type="text" v-model="instanceModal.prsPerson" class="form-control" hidden=""/>									
											</div>
										</div>
										
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
												</label>
												<select v-model="instanceModal.prsStore" class="form-control">
													<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id">
													{{ prsStore.storeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-5">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.mvtBank')}}
												</label>
												<select v-model="instanceModal.mvtBank" class="form-control">
													<option v-for="mvtBank in mvtBankList" :value="mvtBank.id" :key="mvtBank.id">
														{{mvtBank.bankCode}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-7">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.accountNumber')}}
											</label>
											<input type="text" v-model="instanceModal.accountNumber" class="form-control" />
										</div>
										<div class="col-md-6">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.solde')}}
											</label>
											<input type="number" step="any" v-model="instanceModal.solde" class="form-control" @input="amountToLetter($event, 'solde')" @change="amountLetter = {}"/>
											<span v-if="amountLetter && amountLetter.solde != '' " class="amount-letter">
													{{amountLetter.solde}}
												</span>
										</div>
										<div class="col-md-6">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.dateEntry')}}
											</label>
											<input type="date" v-model="instanceModal.dateEntry" class="form-control" />
										</div>

									</div>
								</form>
							</b-container>
							

						</div> <!-- modal-body  -->
						<div class="modal-footer">
							<div class="row d-flex justify-content-end mb-3">
								<!-- <input type="hidden" id="id" name="id" :value="user.id" required> -->

								<!-- INFO v-if="!dataMapShow.readOnlyShow" -->
								<div class="mr-3">
									<button class="btn btn-success" :disabled="loading" @click="axiosPost">
										<span v-show="loading" class="spinner-border spinner-border-sm"/>
										<!-- v-if="!dataMapShow.infos.id" -->
										<span >
											{{ $t('default.button.create') }}
										</span>
										<!-- <span v-if="dataMapShow.infos.id">
											{{ $t('default.button.update') }}
										</span> -->
									</button>
								</div>
								<button type="button" class="btn btn-danger ml-1" @click="modalToggle()">
									{{ $t('default.button.cancel') }}
								</button>
							</div>
						</div> 


					</div> <!-- modal-content  -->
				</div> <!-- modal-dialog  -->
			</div> <!-- ModalInstance  -->
		
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import AutoSearch from '@/components/templates/AutoSearch.vue';
	import Chart from '@/components/templates/charts/Chart.vue';

	export default {
		name: 'mvtAccount',
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'auto-search': AutoSearch,
			'chart': Chart,
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtaccount.label'),
				pageTitle: this.$t('mvtaccount.list'),
				pageIcon: 'list',
				instanceClassAttr: {
					instanceClass: 'mvtaccount',
					titleIndex: 'nav.mvt',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '22%', 
						actAdd: true, 
						actGet: false, 
						actEdit: false, 
						actDel: false, 
						actPrint: 'reportlist'
					},
					attrsList: [
						{attrName: 'prsPersonLib', attrCol: '20%', searchable: true, sortable: true, attrRep: 'toString()'},
						{attrName: 'mvtBankLib', attrCol: '13%', searchable: false, sortable: true, attrRep: ''},
						{attrName: 'accountNumber', attrCol: '13%', searchable: false, sortable: true},
						{attrName: 'solde', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'lastUpdated', attrCol: '8%', searchable: false, sortable: true},
					]
				},
				instance: {
					prsPerson: '',
					prsType: [],
					mvtBank: [],
					prsStore: [],
					accountNumber: '',
					solde: '',
					active: '',
					dateEntryAfter:'',
					dateEntryBefore:''
				},
				vueRules: {},
				paramsSearch: {
					placeholder: 'Search Person',
					instanceClass: 'prsperson',
					attrsSearch : ['firstName', 'lastName'],
					attrView: 'fullName',
					// filterList: [],
					updateOnClick: true,
					btnReturn: false,
					icon: 'user',
				},
				prsPersonLib: '',
				prsTypeList: [],
				mvtBankList: [],
				prsStoreList: [],
				amountLetter: {},
				chartOptions: {
					title: 'Statistique des situations par ',
					hAxis: {title: 'Désignation'},
					vAxis: {title: 'Solde'},
					recap: {title: 'Soldes totaux', val:0}
				},
				chartData: [],
				typeStats: [
					{id: 'prsPerson', label: this.$t('prsperson.label')},
					{id: 'mvtBank', label: this.$t('mvtbank.label')},
					{id: 'prsType', label: this.$t('prstype.label')},
					{id: 'prsStore', label: this.$t('prsstore.label')}
				],
				typeStat: 'prsPerson',
				instanceModal: {
					prsPerson: '',
					prsStore: '',
					mvtBank: '',
					accountNumber: '',
					solde: '',
					active: true,
					dateEntry: new Date ().toISOString().split('T')[0],
				},

				active: false,
				modalType: 'NEW',
				loading: false,
			}
		},
		async mounted () {
			if(this.$store.getters.loggedIn) {
				// GET LIST mvtbank
				await this.$store.dispatch('axiosGet', {
					domain: 'mvtbank'
				})
				.then(response => {
					this.mvtBankList = response.data
				})
				.catch(error => {
					console.log('error catch mvtbank == ', error.message)
				})
				// GET LIST prstype
				await this.$store.dispatch('axiosGet', {
					domain: 'prstype'
				})
				.then(response => {
					this.prsTypeList = response.data
				})
				.catch(error => {
					console.log('error catch prstype == ', error.message)
				})
				
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
					if(this.$store.getters.isAuthorized(['ROLE_VENTE'])){
						this.prsStoreList = this.prsStoreList.filter(item => item.id == this.$store.getters.prsInfo.prsStore)
						// this.instance.prsStore = this.$store.getters.prsInfo.prsStore
						this.instance.prsStore.push(this.$store.getters.prsInfo.prsStore)
					}
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})
				this.search();
			}
			// this.reset()
		},
		methods: {
			reset(){
				this.instance = {
					prsPerson: '',
					prsType: [],
					// prsStore:[],
					mvtBank: [],
					accountNumber: '',
					soldeSup: '',
					soldeEq: '',
					soldeInf: '',
					active: '',
					dateEntryAfter:'',
					dateEntryBefore:'',
					
				};
				if(!this.$store.getters.isAuthorized(['ROLE_VENTE','ROLE_STOCK'])){
					this.instance.prsStore = []
				}
			},
			addPrsPerson(row){
				if(row){
					this.instanceModal.prsPerson = row.id
					this.instance.prsPerson = row.id
					this.prsPersonLib = row.fullName
				}
				else{
					this.instanceModal.prsPerson = ''
					this.instance.prsPerson = ''
				}
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async search() {
				let strParamsForms = "";
				
				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';

				// Date super
				strParamsForms = strParamsForms+"&params1=dateEntry&valParams1="+this.instance.dateEntryAfter+"&logParams1=geD"
				if(this.instance.dateEntryAfter){
					detailsTopC2 = '<i>'+this.$t('default.dateEntryAfter')+' </i><b> '+ this.$moment(this.instance.dateEntryAfter).format(this.$store.getters.formatDateShort) + '</b>'
				}
				
				// Date inf
				strParamsForms = strParamsForms+"&params2=dateEntry&valParams2="+this.instance.dateEntryBefore+"&logParams2=leD"
				if(this.instance.dateEntryBefore){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + ' - '
					else
						detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryAfter')+' </i><b> ... </b>'

					detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryBefore')+' </i><b> '+ this.$moment(this.instance.dateEntryBefore).format(this.$store.getters.formatDateShort) + '</b>'
				}

				strParamsForms = strParamsForms+"&params3=mvtBank.id&valParams3="+this.instance.mvtBank +"&logParams3=inL"
				if(this.instance.mvtBank && this.instance.mvtBank.length >0 ){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.mvtBankList, this.instance.mvtBank, 'bankCode')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.mvtBank')+'(s) : </i><b>'+strLibs + '</b>'
				}
				
				// strParamsForms = strParamsForms+"&params4=prsStore.id&valParams4="+this.instance.prsStore +"&logParams4=eqL"
				strParamsForms = strParamsForms+"&aliasList=_prsPerson"
				
				strParamsForms = strParamsForms+"&params4=_prsPerson.prsStore.id&valParams4="+this.instance.prsStore +"&logParams4=inL"

				if(this.instance.prsStore && this.instance.prsStore.length >0 ){
					// les caisses de store et on va avec or au lieu de and par defaut
					// a revoir search unique ne fonctionne plus - 
					// strParamsForms = strParamsForms+"&params11=prsStore.id&valParams11="+this.instance.prsStore +"&logParams11=inL&logCr=or"


					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.prsStoreList, this.instance.prsStore, 'storeName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.prsStore')+'(s) : </i><b>'+strLibs + '</b>'
				}

				strParamsForms = strParamsForms+"&params5=_prsPerson.prsType.id&valParams5="+this.instance.prsType +"&logParams5=inL"
				if(this.instance.prsType && this.instance.prsType.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.prsTypeList, this.instance.prsType, 'typeName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.prsType')+'(s) : </i><b>'+strLibs + '</b>'
				}
				strParamsForms = strParamsForms+"&params9=prsPerson.id&valParams9="+this.instance.prsPerson +"&logParams9=eqL"
				if(this.instance.prsPerson && this.instance.prsPerson != ''){
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.prsPerson')+' : </i><b>'+ this.prsPersonLib + '</b>'
				}

				// Amout super
				strParamsForms = strParamsForms+"&params6=solde&valParams6="+this.instance.soldeSup+"&logParams6=geDo"
				if(this.instance.soldeSup){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.solde')+' > </i><b> '+this.$store.getters.formatAmount(this.instance.soldeSup) + '</b>'

				}
				// Amout equal
				strParamsForms = strParamsForms+"&params7=solde&valParams7="+this.instance.soldeEq+"&logParams7=eqDo"
				if(this.instance.soldeEq){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.solde')+' = </i><b> '+this.$store.getters.formatAmount(this.instance.soldeEq) + '</b>'
				}
				// Amout inf
				strParamsForms = strParamsForms+"&params8=solde&valParams8="+this.instance.soldeInf+"&logParams8=leDo"

				if(this.instance.soldeInf){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.solde')+' < </i><b> '+this.$store.getters.formatAmount(this.instance.soldeInf) + '</b>'
				}

				strParamsForms = strParamsForms+"&params10=active&valParams10="+this.instance.active+"&logParams10=eqB"

				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2

				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
			drawChart(val) {
				if(val && !Array.isArray(val))
					this.typeStat = val
				
				// default values
				let statLabel = ["Type dépense", "Montant par type de dépense"] 
				let attrKey = 'accountNumber'
				let attrValue = 'solde'

				if(this.typeStat === 'prsPerson' ){
					statLabel = [this.$t('mvtaccount.prsPerson'), "Montant par compte"]
					attrValue = 'solde'
				}
				else if(this.typeStat === 'prsType' ){
					statLabel = [this.$t('prstype.label'), "Montant par type Tiers"]
					attrKey = 'prsPerson.prsType.typeName'
				}
				else if(this.typeStat === 'prsStore' ){
					statLabel = [this.$t('prsstore.label'), "Montant par Store"]
					attrKey = 'prsPerson.prsStore.storeName'
				}
				else if(this.typeStat === 'mvtBank' ){
					statLabel = [this.$t('mvtbank.label'), "Montant par Banque"]
					attrKey = 'mvtBank.bankName'
				}
				var dataList = this.$refs.componentDatatableInstance.drawChart(attrKey, attrValue, null)
				this.chartData = [ statLabel ]
				let sumData = 0;
				dataList?.forEach(data => {
					this.chartData.push(data);
					sumData = sumData + data[1]
				});
				this.chartOptions.recap.val = this.$store.getters.formatAmount(sumData)

				if(this.chartOptions.recap.title && this.chartOptions.recap.val){
					let detailsBot = '&detailsBot=<i> '+ this.chartOptions.recap.title +' : <b> '+ this.chartOptions.recap.val +'</b> </i>';
					this.$refs.componentDatatableInstance.addStrParamsForms(detailsBot);
				}
			},
			modalToggle(type) {
				// this.resetModal()
				this.modalType = type
				// this.language = this.$store.getters.language
				if(this.active)
					this.active = false
				else{
					this.active = true
					this.$nextTick(function(){
						// this.axiosShow(this.modalType)
					});
				}
			},
			async axiosPost() {
				try {
					await this.$store.dispatch('axiosPost', {
						domain: 'mvtaccount',
						data: this.instanceModal //data
					})
					.then(res => {
						this.instanceModal = res.data;
						// console.log('res.data ', res.data)
						this.modalToggle(this.modalType)
						this.$nextTick(() => {
							let msg = this.$t("mvtaccount.label") + " "+res.data.id;
							this.$store.dispatch('showToast', {
								type: 'success', message: this.$t('toast.created.message', { obj: msg})
							});
						});
					})
					.catch(error => {
						console.log('Error', error.response)
					})
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
		}
		
	}

</script>